import React from "react";
import AlbumCard from "./AlbumCard";

export default function AlbumGrid({ albums = [] }) {
  if (!albums.length) {
    return (
      <div style={{
        padding: '2rem',
        textAlign: 'center',
        backgroundColor: 'var(--surface-color)',
        border: '1px solid var(--border-color)',
        borderRadius: '12px',
        color: 'var(--text-secondary)'
      }}>
        <div style={{ fontSize: '3rem', marginBottom: '1rem' }}>🎵</div>
        <p style={{ 
          fontSize: '1.1rem', 
          fontWeight: '600', 
          margin: '0 0 0.5rem 0',
          color: 'var(--text-primary)'
        }}>
          No albums found
        </p>
        <p style={{ 
          fontSize: '0.9rem', 
          margin: '0',
          color: 'var(--text-secondary)'
        }}>
          Albums will appear here as they are added to the catalog.
        </p>
      </div>
    );
  }

  return (
    <div style={{
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))',
      gap: '1.5rem'
    }}>
      {albums.map((album, idx) => (
        <AlbumCard
          key={album.title || idx}
          album={album}
        />
      ))}
    </div>
  );
}
